import { createRouter, createWebHashHistory } from 'vue-router';
import DashboardIndex from '@/pages/DashboardIndex.vue';
import SectionApplication from '@/pages/SectionApplication.vue';
import SectionThankyou from '@/pages/SectionThankyou.vue';
import AgentTable from '@/pages/dashboard-nav/AgentTable.vue';
import GenerateBrokerCode from '@/pages/dashboard-nav/GenerateBrokerCode.vue';
import PendingApproval from '@/pages/dashboard-nav/PendingApproval.vue';
import PendingPrinting from '@/pages/dashboard-nav/PendingPrinting.vue';
import AuthIndex from '@/pages/AuthIndex.vue';
import IndexAgentIdForm from '@/pages/Agent ID/IndexAgentIdForm.vue';
//import store from '../store';

const routes = [
  {
    path: '/',
    name: 'Login',
    component: AuthIndex,
    meta: {
      title: 'Login',
      layout: 'Account',
      requiresAuth: false,
    },
  },
  {
    path: '/agents/register/:code?',
    name: 'Register',
    component: SectionApplication,
    meta: {
      title: 'Register',
      layout: 'Account',
      requiresAuth: false,
    },
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: DashboardIndex,
    meta: {
      title: 'Agent Dashboard',
      layout: 'Account',
      requiresAuth: true,
    },
  },
  {
    path: '/thank-you',
    name: 'Thank you page',
    component: SectionThankyou,
    meta: {
      title: 'Thank you page',
      layout: 'Account',
      requiresAuth: true,
    },
  },
  {
    path: '/agent-table',
    name: 'Agent Table',
    component: AgentTable,
    meta: {
      title: 'Agent Table',
      layout: 'Account',
      requiresAuth: true,
    },
  },
  {
    path: '/broker-code',
    name: 'Generate Broker Code',
    component: GenerateBrokerCode,
    meta: {
      title: 'Generate Broker Code',
      layout: 'Account',
      requiresAuth: true,
    },
  },
  {
    path: '/pending-approval',
    name: 'Pending Approval',
    component: PendingApproval,
    meta: {
      title: 'Pending Approval',
      layout: 'Account',
      requiresAuth: true,
    },
  },
  {
    path: '/pending-printing',
    name: 'Pending for Printing',
    component: PendingPrinting,
    meta: {
      title: 'Pending for Printing',
      layout: 'Account',
      requiresAuth: true,
    },
  },
  {
    path: '/agent/:id',
    name: 'Agent Company ID',
    component: IndexAgentIdForm,
    meta: {
      title: 'Agent Company ID',
      layout: 'Account',
      requiresAuth: false,
    },
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});
document.title = `IWC Agent Management System`;

export default router;
